import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { differenceInMinutes } from 'date-fns';

import { ReportRouteDayTimelineComponent } from './timeline/report-route-day-timeline.component';
import { RoutePartComponent } from './route-part/route-part.component';
import { LanguageService } from '@shared/services/language.service';
import { RouteElementTypeEnum } from '@commons/enums/route-element-type.enum';
import { PipesModule } from '@commons/pipes/pipes.module';
import { formatMinutesToHours } from '@src/app/utils/date';
import { IGroupObjRouteEventReport, IRouteEventReportData } from '@src/app/interfaces/report-route.interface';
import { ITimelineProps } from '@src/app/interfaces/reports/timeline.interface';

@Component({
  selector: 'app-report-day-route-preview',
  standalone: true,
  imports: [ReportRouteDayTimelineComponent, RoutePartComponent, CommonModule, PipesModule],
  templateUrl: './report-day-route-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./report-day-route-preview.component.scss'],
})
export class ReportDayRoutePreviewComponent {
  @Output() public onSelectRoute$: EventEmitter<{ indexRouteInGroup: number, route: IRouteEventReportData }> = new EventEmitter();
  @Output() public toggleVisibility$: EventEmitter<void> = new EventEmitter();

  @Input() public selectedRoute: IRouteEventReportData;
  @Input() public isVisibleContent: boolean;
  @Input('data') public set data(data: IGroupObjRouteEventReport) {
    this._data = {...data};
    this.setRoutes();
    this.calculateDistanceDay();
    this.calculateTimeDriveDay();
    this.calculateStopTimeDay();
  };

  public _data: IGroupObjRouteEventReport;
  public totalDistance: number;
  public totalMinutes: string;
  public stopTime: string;
  public timelineData: ITimelineProps;

  public readonly langauge: string = this.languageService.current;

  constructor(
    private languageService: LanguageService,
  ) {}

  public trackByRoute(index: number, data: IRouteEventReportData): number {
    return data.Id;
  }

  public onSelectRoute(route: IRouteEventReportData, index: number): void {
    this.onSelectRoute$.next({ indexRouteInGroup: index, route });
  }

  public onToggleContentVisible(): void {
    this.toggleVisibility$.emit();
  }

  private setRoutes(): void {
    this.timelineData = {
      routes: this._data.routes.filter(item => item.T === RouteElementTypeEnum.Segment),
      events: this._data.events || [],
    };
  }

  private calculateDistanceDay(): void {
    const totalDistance = this.timelineData.routes.reduce((prev, curr) => {
      return prev + curr.D.D;
    }, 0);
    this.totalDistance = totalDistance;
  }

  private calculateTimeDriveDay(): void {
    const totalMinutes = this.timelineData.routes.reduce((acc, stop) => {
      return acc + differenceInMinutes(new Date(stop.En), new Date(stop.St));
    }, 0);
    this.totalMinutes = formatMinutesToHours(totalMinutes);
  }

  private calculateStopTimeDay(): void {
    const totalMinutes = this.timelineData.routes.reduce((prev, curr) => {
      return prev + (curr.stopTimeInMinutes || 0);
    }, 0);
    this.stopTime = formatMinutesToHours(totalMinutes);
  }

}
